
    function LoadMore() {
        this.name = 'LoadMore';
        this.setup();

        return this;
    }

    LoadMore.prototype.setup = function() {
        this.$loadMore = $('.js-loading-more');
    }


    LoadMore.prototype.show = function() {
        this.$loadMore.css({
            opacity:1,
        });
    }

    LoadMore.prototype.hide = function() {
        this.$loadMore.css({
            opacity:0,
        });
    }
